import InputRange from 'react-input-range'
import styles from './styles/InputRangeFilter.css'
import './styles/InputRangeFilter.global.css'

export const InputRangeFilter = ({
  className,
  step,
  value,
  onChange,
  onChangeStart,
  onChangeComplete,
  minValue,
  maxValue,
  allowSameValues,
  formatLabelFn,
  disabled,
  labelBottom = false
}) => {
  return (
    <InputRange
      classNames={{
        activeTrack: `${styles.track} ${styles.activeTrack}`,
        disabledInputRange: `${styles.range} ${styles.disabledTrack}`,
        inputRange: `${className} ${styles.range}`,
        labelContainer: `input-range__label-container ${styles.labelContainer}`,
        maxLabel: `${styles.hide} input-range__label--max`,
        minLabel: `${styles.hide} input-range__label--min`,
        slider: styles.slider,
        sliderContainer: 'input-range__slider-container',
        track: `${styles.track} input-range__track--background`,
        valueLabel: `${styles.label} ${styles.labelValue} ${labelBottom ? styles.labelBottom : styles.labelTop}`
      }}
      allowSameValues={allowSameValues}
      minValue={minValue}
      maxValue={maxValue}
      step={step}
      value={value}
      onChange={onChange}
      onChangeStart={onChangeStart}
      onChangeComplete={onChangeComplete}
      formatLabel={formatLabelFn}
      disabled={disabled}
    />
  )
}

export default InputRangeFilter
